<template>
  <b-overlay :show="deleting">
    <template #overlay>
      <div class="text-center">
        <b-icon-x-square-fill
          font-scale="3"
          animation="throb"
          :variant="variant"
        ></b-icon-x-square-fill>

        <p>{{ btntext }}ing...</p>
      </div>
    </template>
    <b-modal
      :id="'modal-remove_' + sn"
      centered
      title="Confirm remove"
      ok
      ok-variant="success"
      cancel-variant="danger"
      @ok="queDelete()"
    >
      <template v-slot:modal-ok> Yes, Delete </template>
      <p>Are you sure you want to delete this Question?</p>
    </b-modal>
    <div class="event-card -shadow p-3 m-2">
      <div class="head-flex mt-2">
        <span class="eyebrow"
          ><b-badge variant="info">{{ question.structure }}</b-badge>
          {{
            question.category != "Thirdparty" ? question.category + " >" : ""
          }}
          {{ question.institution }}
          {{ question?.level?.length > 0 && question?.level != 'null' ? " > " + question.level : "" }} >
          <b-badge variant="primary">{{
            question?.course?.length > 0 && question?.course != 'null' ? question.course : question.subject
          }}</b-badge>
        </span>
        <div v-if="display == 'edit'" class="text-right -mt-2">
          <b-icon-three-dots-vertical
            :id="`popover-1-action${sn}`"
            variant="primary"
          ></b-icon-three-dots-vertical>
          <b-popover
            :target="`popover-1-action${sn}`"
            placement="bottomright"
            title=""
            triggers="hover focus"
          >
            <div style="width: 170px; min-height: 40px" class="">
              <div
                class="cursor-pointer action-link p-1 px-2"
                @click="comfirmRemove()"
              >
                <p class="text-sm">{{ btntext }}</p>
              </div>
              <div
                @click="
                  $router.push({
                    name:
                      module == 'thirdparty'
                        ? 'uploadquestionsorg'
                        : 'uploadquestion',
                    params: { trackid: question.track_id }
                  })
                "
                class="cursor-pointer action-link p-1 px-2"
              >
                <p class="text-sm">Edit</p>
              </div>
            </div>
          </b-popover>
        </div>
      </div>

      <!-- <h4 class="title mt-1">{{ question.subject }} Question</h4> -->
      <b-row>
        <b-col cols="12">
          <!-- <h4 class="title pt-2">
            <b-icon-question-diamond-fill></b-icon-question-diamond-fill>
            Question :
          </h4> -->

          <div
            v-if="
              question.isAttachment == 'Yes' ||
                JSON.parse(question.isAttachment)
            "
            class="mb-3 mt-3"
          >
            <img
              :src="question.image_link"
              class="qimage pr-1"
              Alt="Question Image"
            />
          </div>
          <p
            class="mt-3"
            style="font-weight: bold;"
            v-html="question.question"
          ></p>

          <b-form-input
            v-if="question.structure == 'OEQ'"
            id="oeqinput"
            v-model="question.oeq_answer"
            :disabled="true"
            :value="question.oeq_answer"
            placeholder="Type answer here"
            class="oeq-input mt-n3"
          ></b-form-input>

          <div>
            <b-form-radio-group
              id="queoption"
              v-if="question.structure == 'MCQ'"
              stacked
              v-model="question.correct"
              class="form-rad"
            >
              <b-form-radio value="A" :disabled="true">
                <div class="dispf m-0">
                  <!-- <p class="fl1 mr-2">a)</p> -->
                  <p class="fl2" v-html="question.a"></p>
                </div>
              </b-form-radio>
              <b-form-radio value="B" :disabled="true">
                <div class="dispf m-0">
                  <!-- <p class="fl1 mr-2">b)</p> -->
                  <p class="fl2" v-html="question.b"></p>
                </div>
              </b-form-radio>
              <b-form-radio value="C" :disabled="true">
                <div class="dispf m-0">
                  <!-- <p class="fl1 mr-2">c)</p> -->
                  <p class="fl2" v-html="question.c"></p>
                </div>
              </b-form-radio>
              <b-form-radio value="D" :disabled="true">
                <div class="dispf m-0">
                  <!-- <p class="fl1 mr-2">d)</p> -->
                  <p class="fl2" v-html="question.d"></p>
                </div>
              </b-form-radio>
              <b-form-radio v-if="question.e != '' && question.e != '<p></p>'" value="E" :disabled="true">
                <div class="dispf m-0">
                  <!-- <p class="fl1 mr-2">e)</p> -->
                  <p class="fl2" v-html="question.e"></p>
                </div>
              </b-form-radio>
            </b-form-radio-group>
          </div>

          <div v-if="question.structure == 'MCQ'">
            <h5>Correct Answer: {{ question.correct }}</h5>
          </div>
        </b-col>
      </b-row>
    </div>
    <!-- </router-link> -->
  </b-overlay>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: {
    question: {
      type: Object
    },
    sn: {
      type: Number
    },
    module: {
      type: String,
      default: "base"
    },
    display: {
      type: String,
      default: "edit"
    }
  },
  data() {
    return {
      deleting: false
    };
  },
  created() {
    let mathjaxlink =
      this.environ == "development"
        ? "http://localhost/quicktest/plugins/Mathjax/MathJax.js?config=MML_HTMLorMML"
        : "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.0/MathJax.js?config=MML_HTMLorMML";

    window.MathJax = {
      MathML: { extensions: ["mml3.js", "content-mathml.js"] }
    };
    let externalScript = document.createElement("script");
    externalScript.setAttribute("src", mathjaxlink);
    document.head.appendChild(externalScript);
  },
  methods: {
    ...mapActions("admin", ["perfDelete", "fetchForQuestions"]),
    comfirmRemove() {
      this.$bvModal.show(`modal-remove_${this.sn}`);
    },
    queDelete() {
      this.deleting = true;
      let action = "";
      if (this.question.is_deleted == "Yes") {
        action = "Undelete";
      } else {
        action = "Delete";
      }
      let delobj = {
        action,
        trackid: this.question.track_id
      };
      //console.log(delobj);
      return this.perfDelete(delobj).then(() => {
        this.$emit("refetch");
        //this.fetchForQuestions();
        this.deleting = false;
        //console.log(response.data);
      });
    }
  },
  computed: {
    variant() {
      if (this.question.is_deleted == "Yes") {
        return "info";
      } else {
        return "danger";
      }
    },
    variant2() {
      if (this.question.available == "Premium") {
        return "warning";
      } else {
        return "primary";
      }
    },
    btntext() {
      if (this.question.is_deleted == "Yes") {
        return "Undelete";
      } else {
        return "Delete";
      }
    },

    btntext2() {
      if (this.question.available == "Premium") {
        return "Premium";
      } else {
        return "Free";
      }
    }
  }
};
</script>

<style scoped>
.icon {
  width: 25px;
  height: 25px;
  margin-right: 5px;
}

.event-card {
  transition: all 0.2s linear;
  cursor: pointer;
  background-color: lightgray;
  border-radius: 10px 10px;
  height: fit-content;
  max-height: 60vh;
  overflow: auto;
  scrollbar-width: thin;
  min-width: 300px
}

.event-card:hover {
  transform: scale(1.01);
  box-shadow: 0 3px 12px 0 rgba(0, 0, 0, 0.2), 0 1px 15px 0 rgba(0, 0, 0, 0.19);
}

.event-link {
  color: black;
  text-decoration: none;
}
.topright {
  font-size: 20px;
  position: absolute;
  right: 30px;
}

.dispf {
  display: flex;
  cursor: pointer;
}
.head-flex {
  display: flex;
  justify-content: space-between;
}

.action-link:hover {
  background-color: rgb(233, 228, 228);
}

.oeq-input {
  border: 2px solid grey;
  border-top: 0px;
  border-left: 0px;
  border-right: 0px;
  border-radius: 0px;
}
.oeq-input:focus {
  border: 0px;
  box-shadow: 0px;
  outline: none;
}

@media screen and (max-width: 999px) {
  .qimage {
    width: 100%;
    height: 200px;
  }
}

@media screen and (min-width: 999px) {
  .qimage {
    width: 100%;
    height: 250px;
  }
}
</style>
